module.exports = __webpack_public_path__ + "static/media/dark-important.9cc68f9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dark-important.svg
// module id = 842
// module chunks = 7